<template>
  <div class="own-list">
    <el-row class="tac">
      <el-col :span="12">
        <el-menu
          :default-active="mydata.myMenuActive"
          class="el-menu-vertical-demo"
        >
          <!-- <el-menu-item
            index="/layout/list/personalCenter/personalInfor"
            @click="personalInforButton"
          >
            <span>个人信息</span>
          </el-menu-item> -->
          <el-menu-item
            index="/layout/list/myBook"
            @click="myBookButton"
          >
            <div>
              <img src="@/assets/书籍,书本,资源_jurassic-copy.png" alt="" />
              <span>我的图书</span>
            </div>
            <el-icon><ArrowRight /></el-icon>
          </el-menu-item>
          <el-menu-item
            index="/layout/list/myDownloads"
            @click="myDownloadsButton"
          >
             <div>
              <img src="@/assets/下载.png" alt="" />
              <span>我的下载</span>
            </div>
            <el-icon><ArrowRight /></el-icon>
          </el-menu-item>
          <el-menu-item
            index="/layout/list/myCollection"
            @click="myCollectionButton"
          >
            <div>
              <img src="@/assets/收藏 (1).png" alt="" />
              <span>我的收藏</span>
            </div>
            <el-icon><ArrowRight /></el-icon>
          </el-menu-item>
          <el-menu-item
            index="/layout/list/myActivity"
            @click="myActivityButton"
          >
            <div>
              <img src="@/assets/活动管理.png" alt="" />
              <span>我的活动</span>
            </div>
            <el-icon><ArrowRight /></el-icon>
          </el-menu-item>
          <!-- <el-menu-item
            index="/layout/list/personalCenter/myNotifications"
            @click="myNotificationsButton"
          >
            <span>站内通知</span>
          </el-menu-item> -->
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { reactive, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  myMenuActive: "/layout/list/personalInfor",
  
});







watch(
  () => {
    return route.path;
  },
  (nv, ov) => {
    // console.log('nv',nv);
    mydata.myMenuActive = nv;
  },
  {
    immediate: true,
  }
);

//按钮的事件函数
function personalInforButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/personalInfor",
  });
}

//按钮的事件函数
function myBookButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/myBook",
  });
}

//按钮的事件函数
function myDownloadsButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/myDownloads",
  });
}
//按钮的事件函数
function myCollectionButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/myCollection",
  });
}
//按钮的事件函数
function myActivityButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/myActivity",
  });
}
//按钮的事件函数
function myNotificationsButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/myNotifications",
  });
}
</script>

<style scoped  lang="scss">
//目录
.own-list {
  // border: 1px solid red;
  //整体目录宽度
  :deep(.el-row.tac) {
    width: 327px !important;
    .el-col.el-col-12 {
      max-width: auto !important;
    }
  }
  :deep(.el-menu.el-menu--vertical.el-menu-vertical-demo) {
    // width: 180px !important;
    // border: 1px solid rgb(132, 255, 0)(27, 176, 67);
    border-right: none;

    //每个目录
    .el-menu-item {
      width: 327px !important;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f2f2f2;
      justify-content: space-between;
      // display: block;
      padding-left: 0px;
      padding-right: 0px;
      > div {
        display:flex;
        align-items: center;
        // text-align: center;
        > img {
          display: block;
          width: 24px;
          margin-right:10px;
          margin-left:14px;
        }
        > span {
          font-size: 15px;
          font-weight: 400;
          color:#333333;
          letter-spacing: 1px;
          // margin: 0 auto;
        }
      }
    }
  }
}
</style>